module.exports = __webpack_public_path__ + "static/img/gongjiang.48d5f147.png";